import { Howler, Howl } from 'howler';
import { forEach } from 'lodash';

const DEFAULT_VOLUME = 1;

const LIST = [
  {
    key: 'bgm_game',
    sprite: {
      start: [0, 6000],
      loop: [6000, 21000 - 6000, true]
    }
  },
  {
    key: 'bgm_out_game',
    sprite: {
      start: [0, 1714],
      loop: [1714, 15428 - 1714, true]
    }
  },

  {
    key: 'jingle_game_over'
  },
  {
    key: 'jingle_goal'
  },
  {
    key: 'jingle_muteki',
    sprite: {
      start: [0, 80],
      loop: [80, 3220 - 80, true]
    }
  },
  {
    key: 'jingle_result',
    sprite: {
      start: [0, 9600],
      loop: [0, 9600, true]
    }
  },
  {
    key: 'jingle_title',
    sprite: {
      start: [0, 2000],
      loop: [2000, 12666 - 2000, true]
    }
  },

  { key: 'se_add_score' },
  { key: 'se_click_button' },
  { key: 'se_click_cancel' },
  { key: 'se_move_page' },
  { key: 'se_move_view' },
  { key: 'se_player_cure_heart' },
  { key: 'se_player_damage' },
  { key: 'se_player_get_happyturn' },
  { key: 'se_player_get_item' },
  { key: 'se_player_jump' },
  { key: 'se_player_muteki' },
  { key: 'se_player_turn_jump' },
  { key: 'se_shot_handgun' },
  { key: 'se_show_highscore' },
  { key: 'se_show_result_value' },
  { key: 'se_show_total_score' },
  { key: 'se_start_countdown' }
];

let _sounds, _isMute;

export default class SoundController {
  static get length() {
    return LIST.length;
  }

  static load(loaded) {
    _sounds = {};
    document.addEventListener('visibilitychange', () => {
      if (_isMute) return;
      Howler.mute(document.hidden);
    });
    return Promise.all(
      forEach(LIST, ({ key, extension = 'mp3', loop, volume, sprite }) => {
        return new Promise((resolve, reject) => {
          const sound = this._getSound(key, extension, loop, volume, sprite);
          const onLoaded = () => {
            if (loaded) loaded();
            resolve();
          };
          _sounds[key] = sound;
          if (sound.state() === 'loaded') onLoaded();
          sound.on('load', onLoaded);
          sound.on('loaderror', () => {
            console.log(`Load Error: ${key}.${extension}`);
            onLoaded();
          });
        });
      })
    );
  }

  static mute(isMute) {
    _isMute = isMute;
    Howler.mute(isMute);
  }

  static play(key, onComplete = null) {
    const sound = _sounds[key];
    if (sound._sprite.start) {
      sound.play('start');
    } else {
      sound.play();
    }

    sound.once('end', () => {
      if (onComplete) onComplete();
      if (sound._sprite.start && sound._sprite.loop) {
        sound.play('loop');
      }
    });
  }

  static fade(key, duration) {
    _sounds[key].play();
    _sounds[key].fade(1, 0, duration);
  }

  static stop(key) {
    if (!_sounds[key]) return;
    _sounds[key].stop();
  }

  static stopAll() {
    forEach(_sounds, sound => {
      sound.stop();
    });
  }

  static _getSound(
    key,
    extension,
    isLoop = false,
    volume = DEFAULT_VOLUME,
    sprite
  ) {
    const params = {
      src: [require(`@/assets/sound/${key}.${extension}`)],
      loop: isLoop,
      volume: volume
    };
    if (sprite) params.sprite = sprite;
    return new Howl(params);
  }
}
